import { useIntl } from 'react-intl';

import EmptyDashboardIcon from '@/assets/icons/empty-dashboard.svg';
import { EmptyState } from '@/components/ui/empty-state';
import { useAccountSlug } from '@/hooks/use-account-slug';

export function NoOpenings() {
  const intl = useIntl();
  const accountSlug = useAccountSlug();

  return (
    <EmptyState
      icon={EmptyDashboardIcon}
      header={intl.formatMessage({
        defaultMessage: 'Add openings to your dashboard',
        description:
          'Empty org dashboard: prompt to follow roles from Openings',
      })}
      description={intl.formatMessage({
        defaultMessage:
          'Start adding openings to your dashboard to track their data.',
        description:
          'Why the dashboard is empty: no openings pinned for org analytics',
      })}
      buttonTitle={intl.formatMessage({
        defaultMessage: '+ Add openings',
        description: 'CTA: go to openings list to add roles to this dashboard',
      })}
      link={`/${accountSlug}/openings`}
    />
  );
}
